// extracted by mini-css-extract-plugin
module.exports = {"root":"ExtractButton_root__86TwN","PDFDownloadLink":"ExtractButton_PDFDownloadLink__2tLx0"};